/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Transition } from './Transition';
import {
    TransitionFromJSON,
    TransitionFromJSONTyped,
    TransitionToJSON,
    TransitionToJSONTyped,
} from './Transition';
import type { LinkingRule } from './LinkingRule';
import {
    LinkingRuleFromJSON,
    LinkingRuleFromJSONTyped,
    LinkingRuleToJSON,
    LinkingRuleToJSONTyped,
} from './LinkingRule';

/**
 * The whole definition in one response: transitions in engine evaluation order, each with its
 * condition, its configured actions and each action's rules.
 * 
 * One request rather than a waterfall — the editor needs all of it to draw the graph, and the
 * prefetching that makes this affordable is in the view.
 * @export
 * @interface WorkflowDefEditor
 */
export interface WorkflowDefEditor {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefEditor
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefEditor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefEditor
     */
    description?: string;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof WorkflowDefEditor
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof WorkflowDefEditor
     */
    autoEventLinking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefEditor
     */
    readonly owner: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefEditor
     */
    readonly ownerName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkflowDefEditor
     */
    readonly updatedAt: Date | null;
    /**
     * 
     * @type {Array<Transition>}
     * @memberof WorkflowDefEditor
     */
    readonly transitions: Array<Transition>;
    /**
     * 
     * @type {Array<LinkingRule>}
     * @memberof WorkflowDefEditor
     */
    readonly linkingRules: Array<LinkingRule>;
}

/**
 * Check if a given object implements the WorkflowDefEditor interface.
 */
export function instanceOfWorkflowDefEditor(value: object): value is WorkflowDefEditor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('ownerName' in (value as Record<string, any>)) && !('owner_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerName'] === undefined && (value as Record<string, any>)['owner_name'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    if (!('transitions' in value) || value['transitions'] === undefined) return false;
    if ((!('linkingRules' in (value as Record<string, any>)) && !('linking_rules' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkingRules'] === undefined && (value as Record<string, any>)['linking_rules'] === undefined)) return false;
    return true;
}

export function WorkflowDefEditorFromJSON(json: any): WorkflowDefEditor {
    return WorkflowDefEditorFromJSONTyped(json, false);
}

export function WorkflowDefEditorFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefEditor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
        'owner': json['owner'],
        'ownerName': json['owner_name'],
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
        'transitions': ((json['transitions'] as Array<any>).map(TransitionFromJSON)),
        'linkingRules': ((json['linking_rules'] as Array<any>).map(LinkingRuleFromJSON)),
    };
}

export function WorkflowDefEditorToJSON(json: any): WorkflowDefEditor {
    return WorkflowDefEditorToJSONTyped(json, false);
}

export function WorkflowDefEditorToJSONTyped(value?: Omit<WorkflowDefEditor, 'id'|'owner'|'ownerName'|'updatedAt'|'transitions'|'linkingRules'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

